import { ContentGallerySwiper } from '@f-fertighaus/applications/Next/components/common/ContentGallerySwiper/ContentGallerySwiper'
import { HouseCarouselSkeletonLoader } from '@f-fertighaus/applications/Next/components/common/HouseCarouselSkeletonLoader'
import { SimilarHouse as SimilarHouseType } from '@f-fertighaus/applications/Next/types/similarHousesResponse'
import { isNotEmptyArray } from '@f-fertighaus/applications/Next/utils/typeguards/isNotEmptyArray'
import { SimilarHouseCard } from '@f-fertighaus/applications/Next/views/houseDetailPage/HouseSections/sections/SimilarHouses/SimilarHouseCard'

interface SimilarHousesCarouselProps {
  similarHouses: SimilarHouseType[]
  status: 'loading' | 'idle' | 'success' | 'error' | 'houseNid-missing'
}

export const SimilarHousesCarousel = ({
  similarHouses,
  status
}: SimilarHousesCarouselProps) => {
  if (status === 'loading' || status === 'idle') {
    return <HouseCarouselSkeletonLoader />
  }

  if (!isNotEmptyArray(similarHouses)) {
    return null
  }

  return (
    <ContentGallerySwiper<SimilarHouseType>
      data={similarHouses}
      SlideCard={SimilarHouseCard}
      id='similar-houses-swiper'
    />
  )
}
